import { styled } from "styled-components";
import { color } from "styled-system";
import { Box } from "../Box";
import type { DefaultNDSThemeType } from "../theme";

type DropdownMenuContainerProps = {
  id?: string;
  className?: string;
  backgroundColor?: string;
  showArrow?: boolean;
  dataPlacement?: any;
  theme?: DefaultNDSThemeType;
};

const getMenuMargin = (placement, showArrow) => {
  const direction = String(placement).split("-")[0];
  switch (direction) {
    case "top":
      return {
        marginBottom: showArrow ? "4px" : null,
      };
    case "right":
      return {
        marginLeft: showArrow ? "8px" : null,
        marginTop: showArrow ? null : "-8px",
      };
    case "left":
      return {
        marginRight: showArrow ? "8px" : null,
        marginTop: showArrow ? null : "-8px",
      };
    default:
      return {
        marginTop: showArrow ? "4px" : null,
      };
  }
};

const DropdownMenuContainer = styled(Box)<DropdownMenuContainerProps>(
  color,
  ({ dataPlacement, showArrow = true, backgroundColor = "white", theme }: DropdownMenuContainerProps): any => ({
    fontFamily: theme.fonts.base,
    fontSize: theme.fontSizes.base,
    lineHeight: theme.lineHeights.base,
    color: theme.colors.black,
    WebkitFontSmoothing: "antialiased",
    MozOsxFontSmoothing: "grayscale",
    "button, input, textarea": {
      fontFamily: theme.fonts.base,
    },
    borderRadius: theme.radii.medium,
    backgroundColor: theme.colors[backgroundColor],
    borderTop: `1px solid  ${theme.colors[backgroundColor]}`,
    borderBottom: `1px solid ${theme.colors[backgroundColor]}`,
    boxShadow: theme.shadows.medium,
    padding: "7px 0",
    zIndex: "100",
    ...getMenuMargin(dataPlacement, showArrow),
  }),
);

export default DropdownMenuContainer;
